module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec01_pc_15b54ba8300886f1ac580584d48c6d6f.jpg";